import { render, staticRenderFns } from "./[temp].vue?vue&type=template&id=8136ec22&scoped=true&"
import script from "./[temp].vue?vue&type=script&lang=js&"
export * from "./[temp].vue?vue&type=script&lang=js&"
import style0 from "./[temp].vue?vue&type=style&index=0&id=8136ec22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8136ec22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
